<template>
	<div class="Indice_remissivo">
		<p class="indice">
			<strong>Alvará de Aprovação<br /></strong>
			Lei Art. 15, 16, 20, 75<br />
			Decreto Art. 3º, 18, 59
		</p>
		<p class="indice">
			<strong>Alvará de Execução</strong><br />
			Lei Art. 18,  23,  71<br />
			Decreto Art. 3º, 22, 82
		</p>
		<p class="indice">
			<strong>Área não computável</strong><br />
			Lei Art. 108 item 4.4.1<br />
			Decreto Art. 75, 102
		</p>
		<p class="indice">
			<strong>Baixo impacto</strong><br />
			Lei Art. 13
		</p>
		<p class="indice">
			<strong>CEUSO</strong><br />
			Lei Art. 111, <br />
			Decreto Art. 76, 79, 102, 104, 107, 111, item 3.L.4
		</p>
		<p class="indice">
			<strong>Comunique-se</strong><br />
			Lei Art. 57, 59, 70<br />
			Decreto Art. 59, 61, 106
		</p>
		<p class="indice">
			<strong>Despacho</strong><br />
			Lei Art. 18, 28, 29, 55, 60, 69, 96, 114, 115<br />
			Decreto Art. 22, 47, 48, 49, 50, 53, 55, 58, 61, 73, 83, 86, 95, 98, 99, 106, 107, 109
		</p>
		<p class="indice">
			<strong>Instâncias</strong><br />
			Lei Art. 69<br />
			Decreto Art. 58
		</p>
		<p class="indice">
			<strong>Lençol Freático</strong><br />
			Lei Art. 111<br />
			Decreto item 3.H
		</p>
		<p class="indice">
			<strong>Mobiliário</strong><br />
			Lei Art. 3º, 6º, 108<br />
			Decreto Art. 1º, 15, 102, 108, item 5.A
		</p>
		<p class="indice">
			<strong>TEV/COE</strong><br />
			Lei Art. 52, 53, 54, 112<br />
			Decreto Art. 29, 47, 72
		</p>
	</div>
</template>

<script>
export default{
  name: "Indice_remissivo", 
  data(){
    return{
      title: "Índice Remissivo"
    }
  }
}
</script>

<style lang="scss">
@import '../assets/main.scss';
</style>


// WEBPACK FOOTER //
// src/components/Indice_remissivo.vue